import { useAuth } from "@/hooks/use-auth";
import { useChatStore } from "./store";

export function Chat() {
	/** Store */
	const store = useChatStore();

	/** Hooks */
	const { isSignedIn, organization } = useAuth();
	const hasOrganization = !!organization;

	/** Guard */
	if (!isSignedIn) return null;
	if (!hasOrganization) return null;
	if (store.state === "hidden") return null;

	/** Guard */
	return null;
}
